import actionsBlock from './actionsBlock.json';
import customer from "./customer.json";

const frCustomers = {
    ...customer,
    ...actionsBlock,
}

export default frCustomers;
